<template>
    <div class="col-auto d-flex align-items-center">
        <img src="assets/images/photouser.jpg" alt="" class="rounded-circle">
        <router-link to="mySettings" class="ml-2 font-weight-bold text-capitalize">{{fullUsername}}</router-link>
    </div>
</template>


<script>


  export default {
    name: 'user',
    computed:{
      fullUsername(){
        return this.$store.getters.fullUsername
      }
    }
  }

</script>

